import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { SectionTitle } from "components/Layouts";
import { Grid } from "components/Containers";
import { RolesList } from "components/Missions/Roles";
import { TALENT_SIMPLE_ROLES_CONFIG } from "constants/index";
import { TalentSimpleDraftsList } from "components/Missions/Roles/TalentSimple";

/**
 * TalentSimpleRoleSection
 *
 * One status-grouped roles table on the Talent Simple board, paginated on its own.
 *
 * @param {String}  titleId           Message id for the section heading
 * @param {String}  emptyId           Message id shown when the section has no roles
 * @param {Object}  filters           Filters merged into the query alongside `states`
 * @param {Number}  resultsPerPage
 * @param {Element} actionBar         Rendered at the right of the section heading
 * @param {Boolean} mergesAIRequests  List AI role builder requests with the roles, unpaginated
 */
const TalentSimpleRoleSection = ({
  titleId,
  emptyId,
  filters = {},
  resultsPerPage = TALENT_SIMPLE_ROLES_CONFIG.RESULTS_PER_PAGE,
  actionBar,
  mergesAIRequests,
  ...props
}) => (
  <>
    <Grid.col start={1} end={13}>
      <SectionTitle title={<FormattedMessage id={titleId} />} actionBar={actionBar} />
    </Grid.col>
    <Grid.col start={1} end={13}>
      {mergesAIRequests ? (
        <TalentSimpleDraftsList filters={filters} emptyMessage={{ title: titleId, description: emptyId }} />
      ) : (
        <RolesList
          isCardView={false}
          selectable={false}
          filters={filters}
          resultsPerPage={resultsPerPage}
          emptyMessage={{ title: titleId, description: emptyId }}
          {...props}
        />
      )}
    </Grid.col>
  </>
);

TalentSimpleRoleSection.propTypes = {
  titleId: PropTypes.string.isRequired,
  emptyId: PropTypes.string.isRequired,
  filters: PropTypes.object,
  resultsPerPage: PropTypes.number,
  actionBar: PropTypes.element,
  mergesAIRequests: PropTypes.bool,
};

export default TalentSimpleRoleSection;
